import { render, staticRenderFns } from "./smsSent.vue?vue&type=template&id=73475518&"
import script from "./smsSent.vue?vue&type=script&lang=js&"
export * from "./smsSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports